import './App.css';

import Landing from './Views/Landing/Landing';

function App() {
  return (
    <div className="App">
      <Landing />
    </div>
  );
}

export default App;
